<ngx-charts-bar-vertical-stacked
  [view]="view"
  [scheme]="options.colorScheme"
  [results]="data"
  [xAxis]="options.showXAxis"
  [yAxis]="options.showYAxis"
  [legend]="options.showLegend"
  [legendPosition]="options.legendPosition"
  [legendTitle]="options.legendTitle"
  [showXAxisLabel]="options.showXAxisLabel"
  [showYAxisLabel]="options.showYAxisLabel"
  [xAxisLabel]="options.xAxisLabel"
  [yAxisLabel]="options.yAxisLabel"
  [animations]="options.animations">
</ngx-charts-bar-vertical-stacked>